module.exports = __webpack_public_path__ + "img/logo.8218f7ce.png";